import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Get subdomain
const subdomain = window.location.hostname.split('.')[0];
console.log("subdomain====", subdomain);

// Determine root element ID
const rootElementId = subdomain === 'admin' ? 'root' : 'root';

// Dynamically import only the component we need
const RootComponent = lazy(() => {
  if (subdomain === 'admin') {
    return import('./App');
  } else {
    return import('./landingApp/LandingApp').then(module => ({ 
      default: module.default || module.LandingApp 
    }));
  }
});

const root = ReactDOM.createRoot(document.getElementById(rootElementId));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <RootComponent />
      </Suspense>
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();